import { urlQueries } from '$common/utils/url'
let ___languageSsrConfig = {};

try {
  //  将后端渲染的东西序列化成对象
  ___languageSsrConfig = JSON.parse(decodeURIComponent(window.ssrConfig));
} catch (err) { }
const pageHeader = ___languageSsrConfig?.routerConfig?.pageHeader ?? {};
const subLanguage = str => {
  if (!str) {
    return 'en-US'
  }
  str = str.substring(0, 2)
  const obj = {
    en: 'en-US',
    km: 'km-KH',
    zh: 'zh-CN'
  }
  console.log('语种' + obj[str])
  return obj[str] || 'en-US'
  // return obj['km']
  // return obj['en']
  // return obj['zh']
}

let params = pageHeader &&
  pageHeader.AcceptLanguage ||
  pageHeader['accept-language'] ||
  navigator?.language || 'en'

const _query = urlQueries()
if (_query.lang) {
  params = _query.lang
}

export default {
  getPageHeaderCurrentLanguage: subLanguage(params)
}
